const genericCartError = "errorAddToCart";
const inventoryCartError = "errorProductInventory";
function sfccInventoryErrorMessage(pid) {
  return `The product '${pid}' isn't available for quantity`;
}

export { genericCartError, inventoryCartError, sfccInventoryErrorMessage };
